import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function FaviconManager() {
  const location = useLocation();

  useEffect(() => {
    const existingLinks = document.querySelectorAll("link[rel~='icon']");
    existingLinks.forEach((el) => el.remove());

    const link = document.createElement("link");
    link.rel = "icon";

    if (location.pathname.startsWith("/aftersalesservice")) {
      link.type = "image/svg+xml";
      link.href = `/favicon2.svg?v=${Date.now()}`;
    } else {
      link.type = "image/x-icon";
      link.href = `/favicon.ico?v=${Date.now()}`;
    }

    document.head.appendChild(link);
  }, [location.pathname]);

  return null;
}

export default FaviconManager;
